import { render, staticRenderFns } from "./AppTipsIcon.vue?vue&type=template&id=b7706ab4&"
import script from "./AppTipsIcon.vue?vue&type=script&lang=js&"
export * from "./AppTipsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports